<template>
    <div>
        <span>{{ $t('notification.tablePermissionChanged', {
            actor: $_.get(activity, 'actorUser.name'),
            tableName: $_.get(activity, 'payload.tableName')
        }) }}</span>
    </div>
</template>

<script>
export default {
    name: "TablePermissionChanged",
    props: {
        activity: {
            type: Object,
            required: true
        }
    }
};
</script>

